module.exports = {
	"app.intro": "",
	"app.footer-info": " ",
	"app.footer-sign": "<p>© Copyright 2021 FTyC – Todos los derechos reservados",
	"app.min_specs_headline": "",
	"app.min_specs_subheading": "",
	"app.min_specs": "",
	"app.how_it_works": "",
	"app.faq1": "",
	"app.faq2": "",
	"app.step_sms": "<h3>Hemos enviado un SMS a tu celular, por favor ingresá ese código para continuar</h3><p>(el sms puede demorar unos segundos)</p>",
	"app.contact_list_presentation": "<p>Podés comunicarte con nosotros llamando al:</p>",
	"app.step_sms_whatsapp_number": "1-11111-111",
	"app.step_sms_whatsapp_text": "1-11111-111",
	"app.step_sms_whatsapp_label": "1-11111-111",
	"app.whatsapp_timetable": "<p class=\"pd-opening-hours\">Lunes a Viernes 09 - 17hs </p>",
	"app.renaper_step": "A continuación efectuaremos una validación de tu identidad a través del Registro Nacional de las Personas (RENAPER)",
	"app.renaper_step_form": "Este botón te llevará a la página del RENAPER, una vez que hayamos validado tu idendidad podrás seguir con tu solicitud en nuestra web.",
	"app.step_cbu": "<h3>Último paso!</h3><p>Por favor ingresá el CBU de una cuenta sueldo a tu nombre (para depositar el préstamo y debitar la cuota)</p>",
	"app.step_address": "<h3>Ya casi terminás!</h3><p>Por favor confirmanos tu dirección e ingresos mensuales</p>",
	"app.step_incomes": "<p>Por favor ingresá la información de tu último recibo de sueldo o documentación de ingresos más reciente.</p>",
	"app.step_personal_info": "<p>Por favor ingresá tu información personal y los servicios que tenés disponible en tu domicilio.</p>",
	"app.step_service_info": "<p>Por favor ingresá tu información personal y los servicios que tenés disponible en tu domicilio.</p>",
	"app.step_job_info": "<p>Por favor ingresá la información de tus datos laborales.</p>",
	"app.step_email": "<p>Para continuar con tu solicitud por favor ingresá tu correo electrónico.</p>",
	"app.step_upload_info": "<p>Para continuar por favor subí una foto de tu DNI del frente / dorso, 2 servicios y tus últimos 3 bonos de sueldo.</p>",
	"app.step_product": "<h3><b>Felicitaciones</b> estás <b>Pre-APROBADO!</b></h3><p>Para continuar, elegí el monto y las cuotas a solicitar:</p>",
	"app.step_product_label_quota": "cuota",
	"app.step_upload": "<p>Para continuar por favor subí una foto de tu DNI del frente / dorso, 2 servicios y tus últimos 3 bonos de sueldo.</p>",
	"app.step_checkout": "<h3><b>Gracias por tu tiempo!</b></h3><h4>Resumen de tu Solicitud:</h4>",
	"app.contract_advice": "<p>Por favor, abrir, leer y acordar con Demo-creditos.com.ar</p>",
	"app.step_checkout_requested_amount": "Monto del Préstamo:",
	"app.step_checkout_quota_amount": "Valor de la cuota:",
	"app.step_checkout_requested_quotas": "Cuotas:",
	"app.step_checkout_other_costs": "Costos Administrativos:",
	"app.step_checkout_first_payment_date": "Pago de la cuota:",
	"app.step_checkout_first_payment_date_info": "Del 1 al 10 de cada mes.",
	"app.step_checkout_info": "El pago se realiza via Débito Automático desde la cuenta donde se depositó el préstamo.",
	"app.step_email_verification": "<h3><b>Para finalizar con tu préstamo hace clic en el enlace que te enviamos a tu correo electrónico</b></h3>",
	"app.disapproved": "<h3><b>Por el momento no tenemos una oferta de crédito que se ajuste a su perfil.</b></h3>",
	"app.step_documents": "<h3><p>Por favor ingresá la documentación solicitada.</p></h3>",
	"app.step_deposit": "<h3><p>Por favor indícanos la modalidad de depósito.</p></h3>",
	"app.step_credit_card": "<h3><p>Por favor ingresá los datos solicitados de tu tarjeta.</p></h3>",
	"app.step_congratulations_whatsapp_number": "1-11111-111",
	"app.step_congratulations_whatsapp_text": "1-11111-111",
	"app.step_congratulations_whatsapp_label": "1-11111-111",
	"app.step_congratulations_title": "<h3><b>Un asesor se pondrá en contacto con usted</b></h3>",
	"app.step_congratulations_info": "<p>Saludos!</p>",
	"app.step_congratulations_footer": "<p>Puedes comunicarte con nosotros llamando al: </p>"
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/translations/ftyc.json
 ** module id = 1145
 ** module chunks = 0
 **/